/**
 * セクショングループ・セクション一括作成ページ専用i18n定数
 */

export const CREATE_SECTION_GROUP_AND_SECTION_I18N = {
  // ラベル
  // Step 3 で app-section-group-admin-assignment に ng-content で差し込むチェックボックスの文言。
  // {{ i18n.label.xxx }} として create-section-group-and-section.component.html から参照している。
  label: {
    selfAdminGroupLabel: $localize`:@@systemAdmin.createSectionGroupAndSection.label.selfAdminGroupLabel:自分自身の登録先`,
    newAdminGroupLabel: $localize`:@@systemAdmin.createSectionGroupAndSection.label.newAdminGroupLabel:新規ユーザの登録先`,
    assignSelfAsSectionAdmin: $localize`:@@systemAdmin.createSectionGroupAndSection.label.assignSelfAsSectionAdmin:自分自身をセクションの管理者として登録する`,
    registerAsGroupAdmin: $localize`:@@systemAdmin.createSectionGroupAndSection.label.registerAsGroupAdmin:新規ユーザをセクショングループの管理者として登録する`,
    registerAsSectionAdmin: $localize`:@@systemAdmin.createSectionGroupAndSection.label.registerAsSectionAdmin:新規ユーザをセクションの管理者として登録する`,
  },

  // 性別オプション
  sex: {
    male: $localize`:@@systemAdmin.createSectionGroupAndSection.sex.male:男性`,
    female: $localize`:@@systemAdmin.createSectionGroupAndSection.sex.female:女性`,
    other: $localize`:@@systemAdmin.createSectionGroupAndSection.sex.other:その他`,
  },

  // バリデーションメッセージ
  validation: {
    checkFields: $localize`:@@systemAdmin.createSectionGroupAndSection.validation.checkFields:各フィールドの内容を再度確認してください`,
    jsonParseError: $localize`:@@systemAdmin.createSectionGroupAndSection.validation.jsonParseError:[JSON パースエラー]`,
    userDataFormatError: $localize`:@@systemAdmin.createSectionGroupAndSection.validation.userDataFormatError:ユーザーデータ設定のフォーマットにエラーがあります。`,
    zipNotFound: $localize`:@@systemAdmin.createSectionGroupAndSection.validation.zipNotFound:該当する住所が見つかりませんでした`,
  },

  // 重複チェックメッセージ
  duplicate: {
    sectionGroupName: $localize`:@@systemAdmin.createSectionGroupAndSection.duplicate.sectionGroupName:セクショングループ名 "`,
    sectionName: $localize`:@@systemAdmin.createSectionGroupAndSection.duplicate.sectionName:セクション名 "`,
    signInName: $localize`:@@systemAdmin.createSectionGroupAndSection.duplicate.signInName:ユーザーID "`,
    alreadyUsed: $localize`:@@systemAdmin.createSectionGroupAndSection.duplicate.alreadyUsed:" はすでに使用されています`,
  },

  // メッセージ
  message: {
    createSuccess: $localize`:@@systemAdmin.createSectionGroupAndSection.message.createSuccess:セクショングループ・セクションを作成し、新しいユーザーを管理人として割り当てました`,
    sectionGroupCreateError: $localize`:@@systemAdmin.createSectionGroupAndSection.message.sectionGroupCreateError:セクショングループの作成に失敗しました。`,
    sectionCreateError: $localize`:@@systemAdmin.createSectionGroupAndSection.message.sectionCreateError:セクションの作成に失敗しました。`,
    sectionGroupAdminCreateError: $localize`:@@systemAdmin.createSectionGroupAndSection.message.sectionGroupAdminCreateError:セクショングループの管理者の登録に失敗しました。`,
    staffCreateError: $localize`:@@systemAdmin.createSectionGroupAndSection.message.staffCreateError:セクションのスタッフの登録に失敗しました。`,
  },

  // ダイアログ
  dialog: {
    clearTitle: $localize`:@@systemAdmin.createSectionGroupAndSection.dialog.clearTitle:入力内容のクリア`,
    clearMessage: $localize`:@@systemAdmin.createSectionGroupAndSection.dialog.clearMessage:このステップの入力内容をすべてクリアしますか？`,
    clearConfirm: $localize`:@@systemAdmin.createSectionGroupAndSection.dialog.clearConfirm:クリア`,
  },

  // ボタン
  button: {
    close: $localize`:@@systemAdmin.createSectionGroupAndSection.button.close:閉じる`,
  },
} as const;

export type CreateSectionGroupAndSectionI18n = typeof CREATE_SECTION_GROUP_AND_SECTION_I18N;
